/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./JModal.vue?vue&type=template&id=65252e89&"
import script from "./JModal.vue?vue&type=script&lang=js&"
export * from "./JModal.vue?vue&type=script&lang=js&"
import style0 from "./JModal.vue?vue&type=style&index=0&id=65252e89&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports